import React from 'react';
import { ISVGType } from './SVGType';
import { useTheme } from '../../contexts/ThemeContext';


export const TransactionsSvg = (props: ISVGType) => {
  const {darkTheme} = useTheme();
  const { height = 14, width = 20, color = darkTheme? '#ABB9C6' : "#454545" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 8.45243V0.545197L12.0928 0.545197L12.0928 2.39022L16.8371 2.39022L10.7749 8.45243L12.0928 9.77031L18.155 3.70809V8.45243H20ZM0 5.54758V13.4548H7.90724V11.6098H3.16289L9.22511 5.54758L7.90724 4.2297L1.84502 10.2919V5.54758H0Z"
        fill={color}
      />
    </svg>
  )
}

export const BlocksSvg = (props: ISVGType) => {
  const { darkTheme} = useTheme();

  const { height = 20, width = 20, color =  darkTheme? '#ABB9C6' :  "#454545" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask id="mask0_931_910" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_931_910)">
        <path
          d="M9.16667 16.1875V10.4792L4.16667 7.58332V13.2917L9.16667 16.1875ZM10.8333 16.1875L15.8333 13.2917V7.58332L10.8333 10.4792V16.1875ZM10 9.04166L14.9375 6.18749L10 3.33332L5.0625 6.18749L10 9.04166ZM3.33333 14.75C3.06944 14.5972 2.86458 14.3958 2.71875 14.1458C2.57292 13.8958 2.5 13.618 2.5 13.3125V6.68749C2.5 6.38193 2.57292 6.10416 2.71875 5.85416C2.86458 5.60416 3.06944 5.40277 3.33333 5.24999L9.16667 1.89582C9.43056 1.74305 9.70833 1.66666 10 1.66666C10.2917 1.66666 10.5694 1.74305 10.8333 1.89582L16.6667 5.24999C16.9306 5.40277 17.1354 5.60416 17.2813 5.85416C17.4271 6.10416 17.5 6.38193 17.5 6.68749V13.3125C17.5 13.618 17.4271 13.8958 17.2813 14.1458C17.1354 14.3958 16.9306 14.5972 16.6667 14.75L10.8333 18.1042C10.5694 18.2569 10.2917 18.3333 10 18.3333C9.70833 18.3333 9.43056 18.2569 9.16667 18.1042L3.33333 14.75Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
